// extracted by mini-css-extract-plugin
export default {"iconText":"icon-text_iconText__MyHTa","iconP":"icon-text_iconP__hvgwY"};